export const envRelease = process.env.REACT_APP_RELEASE
export const envBuild = process.env.REACT_APP_BUILD
export const envVersion = process.env.REACT_APP_VERSION
